// @flow

// checking arrays full of objects for duplicates
// Example arrays that will be checked :
// [{id: 4},{id: 5}, {id:4}] true
// ["AGE_UNDER_25", undefined, undefined] true
// You can see example in /reporting/1/reports/alert-details then click on new report and observe how
// Initially created for AU-236
export const groupHasDuplicates = (array: Array<Object>): boolean => {
  if (!array) return false;
  const matches = [];
  let hasDuplicates = false;
  array.map &&
    array.map(group => {
      const criteria = typeof group === "string" ? group : (group || {}).id;
      hasDuplicates = matches.indexOf(criteria) >= 0;
      matches.push(criteria);
    });

  return hasDuplicates;
};
